<template>
  <div class="device-card-timestamp">
    Last updated on: {{this._props.timestamp | formatDate }}
  </div>
</template>
<script>
export default {
  name: 'CardTimestampFooter',
  props: ['timestamp'],
}
</script>
<style src="./CardTimestampFooter.scss" lang="scss" scoped/>
